import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Hpe = props => (
  <StyledIcon viewBox='0 0 48 24' a11yTitle='Hpe' {...props}>
    <path fillRule='evenodd' clipRule='evenodd' d='M2 6H46V18H2V6ZM5 9H43V15H5V9Z' fill='#00C781' />
  </StyledIcon>
);
